/**
 * A moeda DIGITADA, idêntica à do admin atual: o que desfaz o texto em número e a máscara do campo.
 *
 * A formatação (`formatarMoeda`) mora em `formatos.ts`; aqui fica só o caminho de volta e a
 * digitação, que são as duas metades que faltavam (peça transversal 1 do inventário,
 * `docs/PARIDADE-ADMIN.md`, `admin.html:7818` a `7834`).
 *
 * POR QUE NÃO O `CampoMoeda` DO CHASSI: o gesto é outro. No Chassi o dígito entra como REAL e a
 * vírgula abre os centavos; no legado CADA DÍGITO ENTRA COMO CENTAVO ("12345" vira "R$ 123,45").
 * Migração reproduz o gesto do legado, então o campo de moeda do admin é o `Campo` do Chassi com
 * esta máscara no `onChange`.
 *
 * Dona desta peça: a frente A5 (Financeiro e Sistema), por designação do principal em 19/09/2026.
 */

// A formatação idêntica à do legado, que a máscara usa para desenhar o valor.
import { formatarMoeda } from './formatos.js';

/**
 * Texto de moeda para número, como `parseMoeda` (`admin.html:7823`): tira "R$", os pontos de milhar
 * e troca a vírgula por ponto. Texto vazio, ou que não vira número, dá 0 e não `NaN`.
 */
export function parseMoeda(texto: string | null | undefined): number {
  // Sem texto, zero, como a primeira linha do legado.
  if (!texto) return 0;
  // O `\s?` também pega o espaço inseparável que o `toLocaleString` põe depois do "R$".
  return parseFloat(texto.replace(/R\$\s?/g, '').replace(/\./g, '').replace(',', '.').trim()) || 0;
}

/**
 * A máscara do legado (`aplicarMascaraMoeda`, `admin.html:7828`), aplicada ao texto que a pessoa
 * acabou de digitar: só os dígitos contam, eles são CENTAVOS, e sem dígito o campo fica vazio.
 *
 * Uso: `<Campo value={v} onChange={(e) => setV(mascararMoedaLegado(e.target.value))} />`.
 */
export function mascararMoedaLegado(digitado: string): string {
  // Tudo que não é dígito some, inclusive o "R$" e a vírgula que já estavam no campo.
  const digitos = digitado.replace(/\D/g, '');
  // Campo esvaziado: vazio, e não "R$ 0,00".
  if (!digitos) return '';
  // Os dígitos são centavos: 12345 vira 123,45.
  return formatarMoeda(parseInt(digitos, 10) / 100);
}
